import React, { useState } from "react";
import { connect } from "react-redux";
import { Button } from "expano-components";

import { Modal } from "components";
import { INSPECTION_QUESTIONS, isIncorrectAnswer } from "./questions";

import { ReactComponent as InfoIcon } from "icons/info.svg";

const InspectionModal = ({ handleClose, onConfirm, is_completing }) => {
  const [answers, setAnswers] = useState({});
  const [notes, setNotes] = useState({});
  const [errors, setErrors] = useState({});

  const validate = () => {
    const nextErrors = {};

    INSPECTION_QUESTIONS.forEach((question) => {
      const { key } = question;

      if (answers[key] === undefined) {
        nextErrors[key] = "Wybierz TAK lub NIE";
        return;
      }

      if (isIncorrectAnswer(question, answers[key]) && !notes[key]?.trim()) {
        nextErrors[`${key}_note`] = "Wpisz uwagę";
      }
    });

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {};
    INSPECTION_QUESTIONS.forEach((question) => {
      const { key } = question;
      payload[key] = answers[key];
      payload[`${key}_note`] = isIncorrectAnswer(question, answers[key])
        ? notes[key].trim()
        : null;
    });

    onConfirm(payload);
  };

  return (
    <Modal
      handleClose={handleClose}
      size="md"
      prevent_click_outside
      header={{ title: "Kontrola dostawy", icon: <InfoIcon /> }}
      footer={
        <>
          <Button
            type="cancel"
            onClick={handleClose}
            disabled={is_completing}
            style={{ marginRight: 15 }}
          />
          <Button
            type="save"
            text={is_completing ? "Proszę czekać..." : "Potwierdź"}
            onClick={handleSubmit}
            disabled={is_completing}
          />
        </>
      }
    >
      <div className="grn-inspection-modal">
        {INSPECTION_QUESTIONS.map((question) => {
          const { key, label } = question;

          return (
          <div className="grn-inspection-modal__item" key={key}>
            <p className="grn-inspection-modal__question">{label}</p>
            <div className="grn-inspection-modal__answers">
              <label>
                <input
                  type="radio"
                  name={key}
                  checked={answers[key] === true}
                  onChange={() =>
                    setAnswers((prev) => ({ ...prev, [key]: true }))
                  }
                />
                TAK
              </label>
              <label>
                <input
                  type="radio"
                  name={key}
                  checked={answers[key] === false}
                  onChange={() =>
                    setAnswers((prev) => ({ ...prev, [key]: false }))
                  }
                />
                NIE
              </label>
            </div>
            {errors[key] && (
              <p className="grn-inspection-modal__error">{errors[key]}</p>
            )}
            {isIncorrectAnswer(question, answers[key]) && (
              <div className="grn-inspection-modal__note">
                <label>Uwagi</label>
                <textarea
                  value={notes[key] || ""}
                  onChange={(event) =>
                    setNotes((prev) => ({
                      ...prev,
                      [key]: event.target.value,
                    }))
                  }
                  placeholder="Wpisz uwagę..."
                />
                {errors[`${key}_note`] && (
                  <p className="grn-inspection-modal__error">
                    {errors[`${key}_note`]}
                  </p>
                )}
              </div>
            )}
          </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default connect(({ grn }) => ({
  is_completing: grn?.is_completing,
}))(InspectionModal);
